import { Progress } from 'antd';
import React from 'react';

interface ProgressBarProps {
  progress: number;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ progress }) => {
  return (
    <Progress
      percent={Math.round(progress)}
      strokeWidth={6}
      strokeColor="#3b82f6"
      trailColor="#e5e5e5"
      showInfo={false}
    />
  );
};

export default ProgressBar;
